import { AddCreativeMediatypeConfig } from "./AddCreativeConfigsUtils";
import { CREATIVE_MEDIATYPES_TYPES } from "../Tabs/CreativeListUtils";
import { TVAD_CONFIG } from "./Configs/TVADAddCreativeConfig";
import * as R from "ramda";

export const mediatypeConfigs: Record<string, AddCreativeMediatypeConfig> = {
  [CREATIVE_MEDIATYPES_TYPES.LINEAR_STREAMING]: TVAD_CONFIG,
};
export const getMediatypeConfig = (mediatype: string): AddCreativeMediatypeConfig => {
  const mediatypeConfig: AddCreativeMediatypeConfig = {
    details: {},
    generateCreatives: () => {},
    getCustomAttributes: () => {},
    renderDuplicateCreatives: () => {},
    renderGeneratedCreatives: () => {},
    saveNewCreatives: () => {},
    updateDetails: () => {},
    ...R.defaultTo({}, mediatypeConfigs[mediatype]),
  };
  mediatypeConfig.details.brandName = {
    type: "dropdown",
    label: "Brand Name",
  };
  return mediatypeConfig;
};
